import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import DeleteBlockedChannels from '../../requests/tasks/user/DeleteBlockedChannelsTask';
import RequestManager from '../../requests/RequestManager';
import channelBlockedUtil from '../../utils/ChannelBlockedUtil';
import store from '../../store';
import { STATUS_CONTROL_PIN_TTL } from '../../AAF/Resilence/TTLConstants';
import AAF from '../../AAF/AAF'

const TTLItem = STATUS_CONTROL_PIN_TTL;

const reminderDelete = (group_id, cb) => {
    let service = new DeleteBlockedChannels(group_id);

    RequestManager.addRequest(service)
        .then((resp) => {
            unblockChannel(group_id);
            if (typeof cb === 'function') return cb(this);
        })
        .catch((err) => {
            console.log('ACÁ ANDAMOS');

            console.error(err);
        });
};

const unblockChannel = (groupId) => {
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setStatusControlPin(); }, 'ModalBorrarCanal[unblockChannel]');
    const { pin_channel } = store.getState().pinCodes;
    const channelList = pin_channel.info ? pin_channel.info : []; //channelBlockedUtil.get('blockedChannels');
    const index = channelList.indexOf(groupId);
    channelList.splice(index, 1);
    channelBlockedUtil.clear();
    channelBlockedUtil.set('blockedChannels', channelList);
};

const ModalBorrarCanal = (props) => {
    const defaultTile = Translator.get('unlock_channel_modal_title', 'Desbloquear Canal');
    const defaultContent = Translator.get(
        'unlock_channel_modal_content',
        '¿Estás seguro que deseas desbloquear este canal?'
    );

    const p = {
        title: defaultTile,
        content: defaultContent,
        buttons: [
            {
                content: 'No',
                props: {
                    onClick: (e) => props.handleClose(e, props.toggleVisibilityStatus),
                },
            },
            {
                content: 'Si',
                props: {
                    onClick: (e) => {
                        reminderDelete(props.group_id, props.service);
                        props.handleClose(e, props.toggleVisibilityStatus);
                    },
                },
            },
        ],
    };

    return <ModalWrapper {...p} />;
};

export default withOnClose(ModalBorrarCanal);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalBorrarCanal.jsx